module.exports = __webpack_public_path__ + "img/icon_maps.3aaf52bc.png";